import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { theme } from '@/Atomic/assets/theme'
import { Icon } from '@/Atomic/Atoms/Icon'
import {
  useAiChatBotEnabled,
  useAiChatBotStore,
} from '@/Atomic/Widgets/AiChatBot'

const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  min-width: 45px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: ${theme.colors.background.subtle};
    box-shadow: 0 4px 0 ${theme.colors.text.primary} inset;
  }
`

export function ChatBotButton() {
  const { t } = useTranslation()
  const enabled = useAiChatBotEnabled()
  const isOpen = useAiChatBotStore((s) => s.isOpen)
  const { toggle } = useAiChatBotStore.getState()

  if (!enabled) return null

  return (
    <>
      <span
        className="vr"
        style={{ alignSelf: 'center', height: 32, opacity: 0.15 }}
      />
      <TriggerButton
        type="button"
        onClick={() => toggle()}
        aria-label={
          isOpen
            ? t('components.aiChatBot.close')
            : t('components.aiChatBot.openAssistant')
        }
      >
        <Icon icon="bubble-chat-ai" color="strong" />
      </TriggerButton>
    </>
  )
}
